import {SpinnerOverlay, SpinnerContainer} from "./spinner.styles";

function Spinner(){
    return(
        <SpinnerOverlay>
            <SpinnerContainer/>
        </SpinnerOverlay>
    );
}

export default Spinner;